var map = {
	"./bd.png": "da91",
	"./bg.png": "ebb5",
	"./br.png": "3115",
	"./ca.png": "026c",
	"./cn.png": "7dc2",
	"./cz.png": "bead",
	"./de.png": "e489",
	"./eg.png": "dea9",
	"./es.png": "2559",
	"./eu.png": "d815",
	"./fr.png": "2176",
	"./gb.png": "6fef",
	"./gr.png": "c115",
	"./hu.png": "4f90",
	"./id.png": "c5d4",
	"./il.png": "5f6c",
	"./in.png": "66d5",
	"./ir.png": "6647",
	"./it.png": "e9d6",
	"./jp.png": "87cc",
	"./ke.png": "71a0",
	"./kp.png": "be0e",
	"./kr.png": "e16c",
	"./lk.png": "d5d6",
	"./md.png": "38a8",
	"./mx.png": "1e05",
	"./my.png": "ebf2",
	"./ne.png": "0abf",
	"./pk.png": "ca04",
	"./pl.png": "b9fd",
	"./pt.png": "5b5c",
	"./ro.png": "09e8",
	"./rs.png": "88aa",
	"./ru.png": "18dd",
	"./sa.png": "6fde",
	"./sk.png": "5254",
	"./tr.png": "cbed",
	"./un.png": "cda1",
	"./us.png": "a396",
	"./vn.png": "b5ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";